import { unloggedStrapiAxios } from '../strapiAxios';
import { capture } from '../../services/sentry/capture';
import AxiosError from '../../helpers/errors/axios.error';

interface RenewPassTypes {
  code: string;
  password: string;
  passwordConfirmation: string;
}

export const renewPassword = ({
  code,
  password,
  passwordConfirmation
}: RenewPassTypes): Promise<string> =>
  unloggedStrapiAxios
    .post('/auth/reset-password', {
      code,
      password,
      passwordConfirmation
    })
    .then(response => {
      console.log("Your user's password has been changed.", response);
      return 'Votre mot de passe a bien été modifié';
    })
    .catch(error => {
      const err = new AxiosError('Changement de MDP', error);
      capture(err);
      return err.message;
    });
